import { FC } from 'react';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/PageHeader';
import { Bookings } from '../components/Bookings/Bookings';

const Home: FC = () => {
    const { t } = useTranslation('home', { keyPrefix: 'HOME' });

    return (
        <div className="screen">
            <Space direction="vertical" size={32} style={{ width: '100%' }}>
                <PageHeader
                    title={t('ACTIVE_BOOKINGS')}
                    style={{ padding: 0 }}
                />
                <Bookings />
            </Space>
        </div>
    );
};

export { Home };
